import React, { useState, useEffect } from 'react';
import ResponsiveAppBar from './ResponsiveAppBar';
import heroImg from '../../assets/img/hero_img.png';
import heroMobImg from '../../assets/img/phone-home.svg';
import bgImg from '../../assets/img/bg-gr.webp';
import { Icon } from '@iconify/react';
import Slider from 'react-slick';
import Footer from './Footer';
import Testimonials from './Testimonials';
// import Pricing from './Pricing';
import Usecases from './Usecases';
import Ourservices from './Ourservices';
import { useLocation } from 'react-router-dom';
import logo from '../../assets/svg/logo_front.svg';
import { useStateContext } from '../../context/ContextProvider';
import { Helmet } from "react-helmet";
import axiosClient from '../../../axios-client';

const Home = () => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [metTitle, setMetaTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');


  useEffect(() => {
    appSettings();
    if (location.pathname === '/') {
      const loadStyles = async () => {
        try {
         
          const tailwindCss = await import('./tailwind.css');
          const style = await import('./index.css');
          const publicTailwindCss = await import('../../../../../public/css/tailwind-output.css');

          // Hide loader after CSS is loaded
          if (tailwindCss && style && publicTailwindCss) {
            setLoading(false);
          }
        } catch (error) {
          console.error("Error loading CSS", error);
        }
      };
      loadStyles();
    }
  }, [ location.pathname ]);
  
  const appSettings = () => {
    axiosClient.get('/app-settings')
      .then(({ data }) => {
          setMetaTitle(data.data.title)
          setMetaDescription(data.data.description);
        })
        .catch(() => {
            setLoading(false)
        })
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '5px',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const cardContent = [
    {
      title: "Scheduled broadcast delivery",
      description: "Plan and automate WhatsApp broadcasts at your most convenient date ans time. With our user-friendly scheduling interface, you can effortlessly plan your broadcasts in advance, ensuring timely delivery to your target audience when they're most receptive.",
      icon: "tabler:calendar-filled"
    },
    {
      title: "Performance analytics tracking",
      // Our Performance Analytics Tracking service offers comprehensive insights into 
      description: "Your business's WhatsApp communication performance. By leveraging advanced tracking algorithms, we provide real-time analytics on various metrics such as message delivery rates, response times, customer engagement levels, and conversion rates.",
      icon: "eva:pie-chart-2-fill"
    },
    {
      title: "Flexible phone number options",
      description: "Our Flexible Phone Number Options service offers unparalleled versatility in managing your WhatsApp business presence. With our platform, you can seamlessly choose and switch between multiple phone numbers, catering to diverse business needs and regional preferences.",
      icon: "line-md:phone-add-twotone"
    },
    {
      title: "Up to 500k contacts per day",
      description: "As soon as you start your account, you can send unlimited messages up to 500.000 contacts per day and per number. We take care of the queue and there is no need for warm up period. The contact list is unlimited and you can upload and dowload it anytime",
      icon: "ic:outline-contact-phone"
    },
    {
      title: "Your own custom template",
      description: "You have a wide selection of Templates that you can use on your dashboard, and you can, at any time, ask for your own custom template in the most user-friendly way. We will make sure these template are in compliance with Meta guidelines and put them directly in your account.",
      icon: "ic:outline-contact-phone"
    },
  ];

  const { token } = useStateContext();

  const goToLogin = async () => {
    token ? window.location.href = '/new-message' : window.location.href = '/login'
  };

  // Loader component
  const Loader = () => (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <div className="row">
        <img className="d-block mx-auto" src={logo} alt="Logo" />
        <div className="mx-auto mt-5 spinner-border text-success" role="status">
        </div>
      </div>
    </div>
  );


  return (
    <>
      <Helmet>
        <title>Home | {metTitle}</title>
        <meta name="description" content={metaDescription}/>
        <meta name="keywords" content="WhatsApp Business, Customer Service, Automations, Broadcasts, AI Chatbots, Lead Qualification" />
      </Helmet>
      {loading ? (
        <div className="h-full w-full">
          <Loader />
        </div>
      ) : (
        <>
          <div className="w-full bg-cover bg-center pb-16" style={{ backgroundImage: `url(${bgImg})` }}>
            <ResponsiveAppBar />
            <div className="flex flex-col md:flex-row items-center justify-between mt-4 px-4 max-w-screen-2xl mx-auto">
              {/* Text Section */}
              <div className="flex-1 text-stat md:text-left mb-4 md:mb-0">
                <h1 className="max-sm:text-center font-bold text-3xl text-white mb-2">Enhance your Customer Service with Whatsapp Business</h1>
                <p className="max-sm:text-center text-lg text-[#B4BCC8] mt-[34px] font-medium">Automations, Broadcasts, Carousels, Chatbots, Forms, Notifications, OTP, and Lead Qualification with Artificial Intelligence.</p>
                <div onClick={goToLogin} className='flex flex-wrap items-center mt-7 max-sm:flex-col mx-auto'>
                  <button type="button" className=' max-sm:text-center max-sm:mx-auto bg-[#6ABA9B] rounded-s-full rounded-e-full p-1 flex items-center justify-between'>
                    <div className="border-[#94D8BE] border-[4px] bg-white rounded-full mr-4">
                      <Icon icon="lets-icons:key" className='p-2 text-[#77808C] text-4xl' />
                    </div>
                      <span className='text-[#CAF9E7] font-bold pr-4 text-sm max-sm:text-center'>Free Trial</span>
                  </button>
                  <span className='max-sm:text-center font-normal text-base ml-4 max-sm:mx-auto max-sm:mt-4'>No code, No credit card required</span>
                </div>
              </div>

              {/* Image Section */}
              <div className="flex-2">
                <img src={heroImg} alt="Description" className="max-h-[620px] max-sm:hidden" />
                <img src={heroMobImg} alt="Description" className="hidden max-sm:block" />
              </div>
            </div>
            <div className='max-sm:h-[1px] max-sm:bg-[#ffffff3f] w-full mb-2'></div>
            <div className="mx-auto">
              <Slider {...settings}>
                {cardContent.map((card, index) => (
                  <div key={index} className="rounded-2xl px-3 mx-auto">
                    <div className='bg-white/10 rounded-2xl px-9 py-6 max-w-[475px]'>
                      <div className="w-[56px] h-[56px] bg-white/10 rounded-full flex items-center justify-center">
                        <Icon icon={card.icon} className="text-2xl p-0 text-white" />
                      </div>
                      <h1 className="text-white text-xl font-bold mt-5">{card.title}</h1>
                      <p className="text-[#B4BCC8] text-sm font-normal mt-4">{card.description}</p>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
          <Ourservices />
          <Usecases />
          {/* <Pricing /> */}
          <Testimonials />
          <Footer />
        </>
      )}
    </>
  )
}

export default Home;
